module.exports = __webpack_public_path__ + "static/media/other.2274b6dd.mp3";